import { Component, Input } from '@angular/core';

@Component({
    selector: 'ca-image-preview',
    templateUrl: './image-preview.component.html',
    styleUrls: ['./image-preview.component.scss'],
    standalone: false
})
export class ImagePreviewComponent {
  @Input() url: string;
  @Input() progress: number;
}
